import React, { useMemo } from 'react';
import { handleCopyClipBoard } from '../../../../api/utils/util-func';
import { useAppDispatch } from '../../../../store/hook';
import {
  closeModal,
  openAlert,
  openModal,
} from '../../../../store/features/modalSlice';
import TextWinds from '../../../common/TextWinds';
import HFbutton from '../../../button/HFbutton';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

interface NewPasswordModalProps {
  type: 'REGIST' | 'RESET';
  uid: string;
  pw: string;
}

/**
 * LMS > 학생 관리 > 학생 등록/비밀번호 초기화 이후 비밀번호 모달 내용
 */
const NewPasswordModalContent = ({ type, uid, pw }: NewPasswordModalProps) => {
  const dispatch = useAppDispatch();

  const msgHead = useMemo(() => {
    if (type === 'REGIST') {
      return '학생등록이';
    } else {
      return '비밀번호 초기화가';
    }
  }, [type]);

  /**
   * 모달은 한 번에 하나만 뜨므로 알림을 띄우면 이 화면이 대체된다.
   * 아이디·비밀번호를 이어서 복사할 수 있도록 알림을 닫을 때 다시 띄운다.
   */
  const copyHandler = (text: string) => {
    handleCopyClipBoard(text).then((result) => {
      if (!result) return;

      dispatch(
        openAlert({
          message: '복사되었습니다.',
          onClose: () =>
            dispatch(
              openModal({
                body: <NewPasswordModalContent type={type} uid={uid} pw={pw} />,
              }),
            ),
        }),
      );
    });
  };

  const closeHandler = () => {
    dispatch(closeModal());
  };
  return (
    <div className="flex flex-col gap-3 rounded bg-white p-5 text-center shadow-card">
      <TextWinds type="title_h2">{msgHead} 완료되었습니다.</TextWinds>
      <table className="min-w-[230px] text-left text-xl font-bold text-purple5">
        <tr>
          <td className="p-1 text-gray7">아이디</td>
          <td
            className="flex cursor-pointer items-center justify-between rounded p-1 hover:bg-gray2"
            onClick={() => copyHandler(uid)}
          >
            {uid}
            <DocumentDuplicateIcon className="inline h-5 w-5" />
          </td>
        </tr>
        <tr>
          <td className="p-1 text-gray7">비밀번호</td>
          <td
            className="flex cursor-pointer items-center justify-between rounded p-1 hover:bg-gray2"
            onClick={() => copyHandler(pw)}
          >
            {pw}
            <DocumentDuplicateIcon className="inline h-5 w-5" />
          </td>
        </tr>
      </table>
      <div className="mt-3 flex gap-1">
        <HFbutton
          type="primary-outlined"
          height={36}
          onClick={() => copyHandler(pw)}
        >
          비밀번호 복사
        </HFbutton>
        <HFbutton height={36} onClick={closeHandler}>
          닫기
        </HFbutton>
      </div>
    </div>
  );
};

export default NewPasswordModalContent;
